module.exports = __webpack_public_path__ + "static/media/HumanistSlabserif712BT-Black.22588435.ttf";